import { autocomplete } from '@algolia/autocomplete-js'
import React, { createElement, Fragment, useEffect, useRef } from 'react'
import { render } from 'react-dom'

const Autocomplete = (props) => {
    const containerRef = useRef(null)

    useEffect(() => {
        if (!containerRef.current) {
            return undefined
        }

        const search = autocomplete({
            container: containerRef.current,
            renderer: { createElement, Fragment, render },
            // onKeyDown: containerRef?.current?.setIsOpen(false),
            ...props,
        })
        // containerRef?.current?.onkeydown(() => search.setIsOpen(false))
        console.log(search, 'search.isOpen')
        return () => {
            search.setIsOpen(false)
            search.destroy()
        }
    }, [props])

    return <div className="customSearch" ref={containerRef} />
}

export default Autocomplete
